import React, { useState, useContext } from "react";
import { AiOutlineWarning } from "react-icons/ai";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../../shared/HelpModal";
import HelpContext from "../../shared/context/HelpProvider";
import CustomAlert from "../../shared/CustemAlert";
import MyJustDate from "../../shared/MyJustDate";

const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({ increment, counter, moamad, hagsha_aharon }) {
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);
  const [newRec, setNewRec] = useState({
    first_name: "",
    last_name: "",
    job: "",
    address: "",
    tel: "",
    moamad: moamad.id,
  });
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const [showCustomAlert, setShowCustomAlert] = useState(false);
  const readOnly =
    moamad.signature_date ||
    MyJustDate(new Date(Date.parse(hagsha_aharon))) < MyJustDate(Date.now());

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setNewRec((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosPrivate.post(baseURL + "recommend/", newRec);
      increment();
      setShowCustomAlert(true);
    } catch (err) {
      // Handle errors
    }
  };

  return (
    <div>
      <HelpModal />
      <center>
        <div className="container">
          <div className="card text-dark bg-light p-3 border">
            {moamad.signature_date ? (
              <h4 style={{ color: "green" }}>
                המעמדות שלך למכרז נחתמה ושוגרה, לא תוכל להוסיף עדכונים.
              </h4>
            ) : (
              <h4 style={{ color: "red" }}>
                <AiOutlineWarning />
                שים לב המועמדות שלך למכרז, עדיין לא נחתמה ולא שוגרה.
                <AiOutlineWarning />
              </h4>
            )}

            <h5
              onClick={() => {
                setSaeef("27-א");
                setShowHelp(true);
              }}
            >
              המלצות של המועמד: {moamad.f_name}{" "}
              {moamad.father_name ? moamad.father_name + " " : ""}{" "}
              {moamad.l_name}
              <span className="help">
                <MdLiveHelp />
              </span>
            </h5>
          </div>
          {!readOnly && (
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label htmlFor="first_name" className="required-label">
                        שם פרטי{" "}
                      </label>
                      <input
                        type="text"
                        name="first_name"
                        className="form-control"
                        id="first_Name"
                        value={newRec.first_name}
                        placeholder="תקליד שם פרטי"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label htmlFor="last_name" className="required-label">
                        שם משפחה
                      </label>
                      <input
                        type="text"
                        name="last_name"
                        className="form-control"
                        id="last_name"
                        value={newRec.last_name}
                        placeholder="תקליד שם משפחה"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label htmlFor="job" className="required-label">
                        תפקיד
                      </label>
                      <input
                        type="text"
                        name="job"
                        className="form-control"
                        id="job"
                        value={newRec.job}
                        placeholder="תקליד תפקיד"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label htmlFor="address" className="required-label">
                        כתובת
                      </label>
                      <input
                        type="text"
                        name="address"
                        className="form-control"
                        id="address"
                        value={newRec.address}
                        placeholder="תקליד כתובת"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={8}>
                    <div className="form-group">
                      <label htmlFor="tel" className="required-label">
                        טלפון
                      </label>
                      <input
                        type="text"
                        name="tel"
                        className="form-control"
                        id="tel"
                        value={newRec.tel}
                        placeholder="תקליד טלפון"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                </Row>
                <br />
                <button type="submit" className="btn btn-primary">
                  הוסף
                </button>
              </form>
              {showCustomAlert && (
                <div className="alert-max-width">
                  <CustomAlert
                    setShow={setShowCustomAlert}
                    alertHeader="הוספת המלצה למועמד"
                    alertBody="ההמלצה נוספה בהצלחה"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </center>
    </div>
  );
}
